import React, { useEffect, useState } from "react";
import Layout from "../../../common/layout";
import { useTranslation } from "react-i18next";
import ListTable from "../../../../elements/list/list";
import { Container } from "../../../common/layout/styels";
import ViewFiles from "../../documents/ViewFiles";
import { useSelector } from "react-redux";
import { getData } from "../../../../../backend/api";
// import NationalityChart from "./chart";
import moment from "moment";

const IllnessReport = (props) => {
  const { t } = useTranslation();

  let date = moment(new Date());

  const user = useSelector((state)=> state.login)

  const [userCountNation, setUserCountNation] = useState([]);

  const [attributes] = useState([
          {
            type: "select",
            placeholder: "fullName",
            name: "user",
            validation: "",
            default: "",
            collection: "user",
            showItem: "fullName",
            label: "fullName",
            required: false,
            filter: false,
            view: true,
            add: false,
            update: false,
          },
          {
            type: "multiSelect",
            placeholder: "employee",
            name: "user",
            tags: [
              { item: "title", title: "place", collection: "place" },
              { item: "title", title: "shift", collection: "shiftTemplate" },
            ],
            validation: "",
            default: "",
            label: "employee",
            showItem: "employee",
            required: true,
            view: false,
            add: true,
            update: false,
            apiType: "API",
            selectApi: "user/select",
          },
          {
            type: "date",
            placeholder: "startDate",
            name: "startDate",
            validation: "",
            minDate: date.clone(),
            maxDate: date.clone().add(3, "months"),
            default: date.clone().startOf("day").add(7, "hours"),
            label: "startDate",
            required: true,
            view: true,
            add: true,
            update: false,
          },
          {
            type: "date",
            placeholder: "endDate",
            name: "endDate",
            validation: "",
            greater: "endEnd",
            minDate: date.clone().add(1, "days"),
            maxDate: date.clone().add(3, "months"),
            default: date.clone().startOf("day").add(15, "hours"),
            label: "endDate",
            required: true,
            view: true,
            add: true,
            update: false,
          },
          {
            type: "select",
            placeholder: "leaveType",
            name: "leaveType",
            validation: "",
            default: "",
            collection: "leaveType",
            label: "leaveType",
            showItem: "locale",
            required: true,
            view: true,
            add: true,
            update: false,
            apiType: "API",
            selectApi: "leave-type/select",
          },
          {
            type: "textarea",
            placeholder: "reason",
            name: "note",
            validation: "",
            default: "",
            label: "reason",
            required: true,
            view: true,
            add: true,
            update: false,
          },
          {
            type: "date",
            placeholder: "appliedOn",
            name: "createdAt",
            validation: "",
            minDate: date.clone(),
            maxDate: date.clone().add(3, "months"),
            default: date.clone().startOf("day").add(7, "hours"),
            label: "appliedOn",
            required: false,
            view: true,
            add: false,
            update: false,
          },
          {
            type: "icon",
            placeholder: "approval",
            name: "approval",
            validation: "",
            default: "",
            label: "approval",
            required: true,
            view: true,
            add: false,
            update: false,
          },
          {
            type: "select",
            placeholder: "approval",
            name: "approval",
            validation: "",
            default: "",
            label: "approval",
            required: true,
            apiType: "JSON",
            selectApi: [
              { id: "Confirmed", value: t("Confirmed") },
              { id: "Rejected", value: t("Rejected") },
            ],
            view: false,
            add: false,
            update: false,
          },
        ]);

  //to update the page title
  useEffect(() => {
    document.title = `${t("Illness")} - PersoBase`;
  }, [t]);
  

  const transformData = (data, t) => {
  const monthLabels = [];
  const approvalMap = {}; // This will hold raw counts per approval status
  const date = new Date();

  data?.data?.forEach((monthData) => {
    const { month, approvals } = monthData;
    const monthIndex = month - 1;

    // Create translated label for month
    monthLabels[monthIndex] = `${t(`month-${month}`)} ${data.year}`;

    // Fill approvalMap with count values
    Object.entries(approvals).forEach(([status, count]) => {
      const translatedStatus = t(status); // Translated label for chart
      if (!approvalMap[translatedStatus]) {
        approvalMap[translatedStatus] = new Array(12).fill(0);
      }
      approvalMap[translatedStatus][monthIndex] = count;
    });
  });

  return {
    series: Object.entries(approvalMap).map(([key, data]) => ({
      name: key,
      data, // raw count data
    })),
    categories: monthLabels,
  };
};

  // Use the useTranslation hook from react-i18next to handle translations
  // const parkingDuration = totalDuration > 120 ? (days > 0 ? days + `d, ` : ``) + (hours > 0 ? hours + `h, ` : ``) + (minutes + t("m")) : totalDuration.toFixed(0) + ` ` + t("minutes");
  return (
    <Container style={{flexDirection:'column'}} className="noshadow">
      <ListTable bulkUplaod={false} {...props} api={`leave-request/sick`} itemTitle={`fullName`} shortName={`Illness`} viewDetails={false} addPrivilege={false} delPrivilege={false} updatePrivilege={false} selectPrivilege={false} attributes={attributes} formMode="double" moreOptions={false} popUpUsingId={false} chart={'report/illness'} datefilter={true} transformData={transformData} ></ListTable>
    </Container>
  );
};
// exporting the page with parent container layout..
export default Layout(IllnessReport);
